import React from 'react';

import {
  Label,
  Required,
  SelectDisplay,
  SelectContain,
  PlaceHolderText,
  SelectContainer,
} from './Styled';

import ErrorInput from '../ErrorInput';

export const SelectInput = ({
  name,
  bold,
  label,
  value,
  onBlur,
  required,
  children,
  onChange,
  errorText
}) => {
  return (
    <SelectContainer>
      <Label error={!!errorText}>{label}{required && <Required>*</Required>}</Label>
      <SelectContain error={!!errorText}>
        {!value && <PlaceHolderText>{label}</PlaceHolderText>}
        <SelectDisplay
          name={name}
          bold={bold}
          value={value}
          error={!!errorText}
          onBlur={(e) => onBlur && onBlur(e)}
          onChange={(e) => onChange && onChange(e)}
        >
          {children}
        </SelectDisplay>
      </SelectContain>
      <ErrorInput errorText={errorText} />
    </SelectContainer>
  );
};

export default SelectInput;